import { Grid2 as Grid } from '@mui/material';
import React from 'react';

import { FilterTextField } from '../FilterTextField/FilterTextField';

interface Props {
  labelFrom: string;
  fieldNameFrom: string;
  labelTo: string;
  fieldNameTo: string;
  replaceRegex?: RegExp;
  fieldType?: 'price' | 'livingSpace' | 'default';
}

export const FromToFilter: React.FC<Props> = ({
  labelFrom,
  fieldNameFrom,
  labelTo,
  fieldNameTo,
  replaceRegex,
  fieldType = 'default',
}: Props) => (
  <Grid container spacing={3}>
    <Grid size={6}>
      <FilterTextField label={labelFrom} fieldName={fieldNameFrom} replaceRegex={replaceRegex} fieldType={fieldType} />
    </Grid>
    <Grid size={6}>
      <FilterTextField label={labelTo} fieldName={fieldNameTo} replaceRegex={replaceRegex} fieldType={fieldType} />
    </Grid>
  </Grid>
);
